import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RecommendationLog, RecommendationLogCreate, RecommendationLogFilter } from '../data/recommendationLog';

export function createRecommendationLogService(client: AxiosInstance) {
  return createCrudService<RecommendationLog, RecommendationLogCreate, RecommendationLogFilter>(
    client,
    '/ai/RecommendationLog',
    'id',
  );
}

export type RecommendationLogService = CrudService<RecommendationLog, RecommendationLogCreate, RecommendationLogFilter>;
